import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Row, Button, Col } from "reactstrap";
import APICall from "../../services/apiCall";
import Loader from "../common/Loader";
import AppContext from "../../context/Context";
import APIPortalTable from "../common/Table/APIPortalTable";
import "../../style.css";
import SikkaSelect from "../common/SikkaSelect/SikkaSelect";
import { CSVLink } from "react-csv";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { Alert } from "reactstrap";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { CaptitalizeString } from "../../helpers/utils";

const arrayEquals = (a, b) => {
  return (
    Array.isArray(a) &&
    Array.isArray(b) &&
    a.length === b.length &&
    a.every((val, index) => {
      const foundSameBillingIn2Array = b.find((data) => data === val);
      return val === foundSameBillingIn2Array;
    })
  );
};

const EditPracticeLocationModal = ({
  masterCustomerID,
  devid,
  applicationDetails,
  activity,
  selectCustomerForPracticeLocationUpdate,
  setEditPracticeLocationModal,
  setUpdateDataFlag,
  isActionAllowed,
  isNewCustomerFlow = false,
  isApiAccessOnFlow = false,
  onCreateCustomer,
  onSaveSuccess,
}) => {
  const [loading, setLoading] = useState(false);
  const [fetchData, setFetchData] = useState(true);
  const [practiceLocationData, setPracticeLocationData] = useState([]);
  const [selectedBillingPractice, setSelectedBillingPractice] = useState({});
  const [
    selectedPracticeLocationsPreviousCopy,
    setSelectedPracticeLocationsPreviousCopy,
  ] = useState([]); // need
  const [selectedPracticeLocations, setSelectedPracticeLocations] = useState(
    []
  ); // need
  // const [selectedPracticeLocationsIdx, setSelectedPracticeLocationsIdx] = useState([]);
  const [
    selectedBillingPracticeWithPracticeID,
    setSelectedBillingPracticeWithPracticeID,
  ] = useState({
    selectObj: {
      value: "",
      label: "",
    },
    practice_id: "",
  });
  const [
    collectionBillingPracWithPracticeIDCopy,
    setCollectionBillingPracWithPracticeIDCopy,
  ] = useState([]);
  const [
    collectionBillingPracWithPracticeID,
    setCollectionBillingPracWithPracticeID,
  ] = useState([]);
  // const [defaultSelectedPracticesPreviousCopy, setDefaultSelectedPracticesPreviousCopy] = useState(
  //   selectCustomerForPracticeLocationUpdate.practice_id1 !== "--"
  //     ? selectCustomerForPracticeLocationUpdate.practice_id1.split(",")
  //     : []
  // );
  const [defaultSelectedPractices, setDefaultSelectedPractices] = useState(
    selectCustomerForPracticeLocationUpdate.practice_id1 &&
    selectCustomerForPracticeLocationUpdate.practice_id1 !== "--"
      ? selectCustomerForPracticeLocationUpdate.practice_id1.split(",")
      : []
  );
  const [
    billingMappingFromSelectedCustomer,
    setBillingMappingFromSelectedCustomer,
  ] = useState(
    selectCustomerForPracticeLocationUpdate.billing_mapping
      ? selectCustomerForPracticeLocationUpdate.billing_mapping.split(",")
      : []
  );
  const [
    changedBillingPracticeCollection,
    setChangedBillingPracticeCollection,
  ] = useState([]);

  let defaultSelectedPracticesTemp = {};

  const getDefaultPractices = () => {
    if (
      selectCustomerForPracticeLocationUpdate.practice_id1 &&
      selectCustomerForPracticeLocationUpdate.practice_id1 !== "--"
    ) {
      let defaultSelectedPracticesArray = selectCustomerForPracticeLocationUpdate.practice_id1.split(
        ","
      );
      defaultSelectedPracticesArray.forEach(
        (id) => (defaultSelectedPracticesTemp[id] = true)
      );
    }

    return defaultSelectedPracticesTemp;
  };

  const [rowSelection, setRowSelection] = useState(getDefaultPractices());
  // useState(
  //   selectCustomerForPracticeLocationUpdate.practice_id1 !== "--"
  //     ? selectCustomerForPracticeLocationUpdate.practice_id1.split(",").map((id) => ({ id: true }))
  //     : {}
  // );

  const { loginUserDetails, isDark } = useContext(AppContext);

  const [enterpriseFeeConfig, setEnterpriseFeeConfig] = useState({
    fees: "",
    locations: "",
  });

  useEffect(() => {
    const billingDevId =
      loginUserDetails?.is_partner === "1"
        ? loginUserDetails?.parent_dev_id
        : devid;

    if (!applicationDetails?.app_id || !billingDevId) {
      return;
    }

    APICall.servertrip(
      "GET",
      "partner_billing_config_info",
      loginUserDetails,
      { app_id: applicationDetails.app_id, dev_id: billingDevId }
    ).then(
      (res) => {
        const item = res?.data?.items?.[0];
        if (item) {
          setEnterpriseFeeConfig({
            fees: item.enterprice_fees ? item.enterprice_fees : "",
            locations: item.enterprice_locations
              ? item.enterprice_locations
              : "",
          });
        }
      },
      () => {
      }
    );
  }, [applicationDetails, devid, loginUserDetails]);

  const enterpriseLocationThreshold =
    Number(enterpriseFeeConfig.locations) || 0;

  const isEnterpriseFeeEnabled =
    enterpriseLocationThreshold > 0 && Number(enterpriseFeeConfig.fees) > 0;

  const showEnterpriseFeeAlert =
    isEnterpriseFeeEnabled &&
    defaultSelectedPractices?.length >= enterpriseLocationThreshold;

  useEffect(() => {
    // partners_customer_list?optflag=1&appid=appid
    if (fetchData) {
      setLoading(true);
      let params = {
        master_customer_id: masterCustomerID,
      };

      APICall.servertrip(
        "GET",
        "practice_location_list",
        loginUserDetails,
        params
      ).then(
        (res) => {
          let items = res.data.items;
          setPracticeLocationData(
            items?.map((data, index) => {
              return { index, ...data };
            })
          );
          if (defaultSelectedPractices.length > 0) {
            setSelectedPracticeLocations(
              items
                .map((data) =>
                  defaultSelectedPractices.find((prac) => {
                    return prac === data.practice_id;
                  })
                    ? data
                    : []
                )
                .filter((e) => e.length || Object.keys(e).length)
            );
            // handling mix match of old selected pratice locations and new selected practice locations condition
            if (
              items
                .map((data) =>
                  defaultSelectedPractices.find(
                    (prac) => prac === data.practice_id
                  )
                    ? data
                    : []
                )
                .filter((e) => e.length || Object.keys(e).length).length === 0
            ) {
              setBillingMappingFromSelectedCustomer([]);
            }
            setSelectedPracticeLocationsPreviousCopy(
              items
                .map((data) =>
                  defaultSelectedPractices.find(
                    (prac) => prac === data.practice_id
                  )
                    ? data
                    : []
                )
                .filter((e) => e.length || Object.keys(e).length)
            );
          }
          setSelectedBillingPractice({
            value: 0,
            label: items[0]?.practice_name,
          });

          //setCollectionBillingPracWithPracticeID
          if (items.length > 0 && billingMappingFromSelectedCustomer) {
            setCollectionBillingPracWithPracticeID(
              items.map((prac, index) => {
                let foundFromBilingMapping = billingMappingFromSelectedCustomer.find(
                  (d, ind) => {
                    return prac.practice_cust_id === d.split(":")[0];
                  }
                );
                let foundIdx = items.findIndex(
                  (d) =>
                    d.practice_cust_id === foundFromBilingMapping?.split(":")[1]
                );
                if (foundFromBilingMapping && foundIdx != -1) {
                  let found = items.find((data, idx) => {
                    if (billingMappingFromSelectedCustomer[index]) {
                      //we have a billing mapping for each practice_id
                      return (
                        data.practice_cust_id ===
                        foundFromBilingMapping?.split(":")[1]
                      );
                    }
                    return prac;
                  });

                  return {
                    selectObj: {
                      value: foundIdx !== -1 ? foundIdx : index, // if there is billing mapping then dropdown idx or by default place order idx
                      label: found.practice_name,
                    },
                    practice_id: prac.practice_id,
                  };
                } else {
                  return {
                    selectObj: {
                      value: index, // if there is billing mapping then dropdown idx or by default place order idx
                      label: prac.practice_name,
                    },
                    practice_id: prac.practice_id,
                  };
                }
              })
            );
            setCollectionBillingPracWithPracticeIDCopy(
              items.map((prac, index) => {
                let foundFromBilingMapping = billingMappingFromSelectedCustomer.find(
                  (d, ind) => {
                    return prac.practice_cust_id === d.split(":")[0];
                  }
                );
                let foundIdx = items.findIndex(
                  (d) =>
                    d.practice_cust_id === foundFromBilingMapping?.split(":")[1]
                );
                if (foundFromBilingMapping && foundIdx != -1) {
                  let found = items.find((data, idx) => {
                    if (billingMappingFromSelectedCustomer[index]) {
                      //we have a billing mapping for each practice_id
                      return (
                        data.practice_cust_id ===
                        foundFromBilingMapping?.split(":")[1]
                      );
                    }
                    return prac;
                  });
                  return {
                    selectObj: {
                      value: index,
                      label: found.practice_name,
                    },
                    practice_id: prac.practice_id,
                  };
                } else {
                  return {
                    selectObj: {
                      value: index, // if there is billing mapping then dropdown idx or by default place order idx
                      label: prac.practice_name,
                    },
                    practice_id: prac.practice_id,
                  };
                }
              })
            );
          } else {
            setCollectionBillingPracWithPracticeID(
              items.map((prac, index) => {
                return {
                  selectObj: {
                    value: index,
                    label: prac.practice_name,
                  },
                  practice_id: prac.practice_id,
                };
              })
            );
            setCollectionBillingPracWithPracticeIDCopy(
              items.map((prac, index) => {
                return {
                  selectObj: {
                    value: index,
                    label: prac.practice_name,
                  },
                  practice_id: prac.practice_id,
                };
              })
            );
          }

          setLoading(false);
          setFetchData(false);
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          toast.error(resMessage);
          setLoading(false);
          setFetchData(false);
        }
      );
    }
  }, [fetchData]);

  useEffect(() => {
    if (selectedBillingPracticeWithPracticeID.practice_id) {
      if (
        collectionBillingPracWithPracticeID.find(
          (data) =>
            data.practice_id ===
            selectedBillingPracticeWithPracticeID.practice_id
        )
      ) {
        // replace
        var foundIdx = collectionBillingPracWithPracticeID.findIndex(
          (x) =>
            x.practice_id === selectedBillingPracticeWithPracticeID.practice_id
        );

        collectionBillingPracWithPracticeID[foundIdx].selectObj =
          selectedBillingPracticeWithPracticeID.selectObj;
        setCollectionBillingPracWithPracticeID(
          collectionBillingPracWithPracticeID
        );
      } else {
        //add to collection
        setCollectionBillingPracWithPracticeID(
          collectionBillingPracWithPracticeID.concat(
            selectedBillingPracticeWithPracticeID
          )
        );
      }
    }
  }, [selectedBillingPracticeWithPracticeID]);

  const cusTomSort = (a, b, order, dataField) => {
    const aMatch = a.match(/[A-Za-z]/g);
    const bMatch = b.match(/[A-Za-z]/g);
    const aResult = aMatch?.toString()?.replaceAll(",", "");
    const bResult = bMatch?.toString()?.replaceAll(",", "");

    if (aResult && bResult) {
      if (order === "asc") {
        return bResult.localeCompare(aResult);
      }

      return aResult.localeCompare(bResult);
    } else {
      const aMatch = a.match(/[0-9]/g);
      const bMatch = b.match(/[0-9]/g);
      const aResult = aMatch?.toString()?.replaceAll(",", "");
      const bResult = bMatch?.toString()?.replaceAll(",", "");

      if (order === "asc") {
        return parseFloat(bResult) - parseFloat(aResult);
      }
      return parseFloat(aResult) - parseFloat(bResult); // desc
    }
  };

  let materialColumns = [
    {
      accessorKey: "practice_id",
      header: "Practice ID",
      Cell: ({ cell, column, renderedCellValue, row, table }) => {
        return <div>{renderedCellValue === "" ? "--" : renderedCellValue}</div>;
      },
      sort: true,
      csvExport: true,
      csvFormatter: (row) => {
        return `${row === "" ? "--" : row}`;
      },
      enableResizing: true,
      sortFunc: cusTomSort,
    },
    {
      accessorKey: "practice_name",
      header: "Practice Name",
      Cell: ({ renderedCellValue }) => {
        return <div>{renderedCellValue === "" ? "--" : renderedCellValue}</div>;
      },
      sort: true,
      csvExport: true,
      csvFormatter: (row) => {
        return `${row === "" ? "--" : row}`;
      },
      enableResizing: true,
    },
    {
      accessorKey: "practice_id_name",
      header: "Billing Practice",
      size: 300,
      muiTableBodyCellProps: ({cell, table})=>{
        return {
          sx: {
            position: "static",
            zIndex:"unset",
            // backgroundColor:"auto"
            // backgroundColor:isDark ? "#223c60" : "#d2e0f4"
          },
        };
      },
      
      Cell: ({ cell, column, renderedCellValue, row, table }) => {
        let extraData = table
          .getPreFilteredRowModel()
          .rows.map((row) => row.original);
        let defaultValue = {};

        let selectedBillingPractice = extraData.find((data) => {
          return (
            data.practice_cust_id ===
            billingMappingFromSelectedCustomer
              .find((mapping) =>
                mapping.startsWith(row.original.practice_cust_id)
              )
              ?.split(":")[1]
          );
        });
        if (selectedBillingPractice) {
          defaultValue = {
            value: selectedBillingPractice.index,
            label: selectedBillingPractice.practice_id_name,
          };
        } else {
          defaultValue = {
            value: row.index,
            label: extraData[row.index].practice_id_name,
          };
        }
        return (
          <>
            {!extraData ? (
              <Loader />
            ) : loginUserDetails.is_partner === "0" ? (
              <>
                <SikkaSelect
                  // styles={styles}
                  className="P-L-M-Select"
                  classNamePrefix="react-select"
                  menuPlacement="auto"
                  menuPosition="fixed"
                  //   maxMenuHeight="300"
                  options={extraData.map((practiceLoc, index) => {
                    return {
                      value: index,
                      label: `${practiceLoc?.practice_id_name}`,
                    };
                  })}
                  defaultValue={defaultValue}
                  isSearchable={true}
                  noOptionsMessage={() => "No Applications"}
                  onChange={(selectedOption) => {
                    let selectedOptionDuplicate = Object.assign(
                      {},
                      selectedOption
                    );
                    selectedOptionDuplicate["label"] = extraData.find(
                      (data) => data.index === selectedOption.value
                    ).practice_name;
                    setSelectedBillingPractice(selectedOptionDuplicate);
                    setSelectedBillingPracticeWithPracticeID({
                      selectObj: selectedOptionDuplicate,
                      practice_id: row.original.practice_id,
                    });

                    let newChangedBillingPRacticeCollection = changedBillingPracticeCollection;

                    if (
                      newChangedBillingPRacticeCollection.findIndex(
                        (d) => d?.value !== selectedOptionDuplicate.value
                      ) === -1
                    ) {
                      newChangedBillingPRacticeCollection.push(
                        selectedOptionDuplicate
                      );
                    }

                    setChangedBillingPracticeCollection(
                      newChangedBillingPRacticeCollection
                    );
                  }}
                />
              </>
            ) : selectedBillingPractice ? (
              selectedBillingPractice.practice_id_name.split("|")[1]
            ) : (
              row.practice_name
            )}
          </>
        );
      },
      sort: true,
      csvExport: true,
      csvFormatter: (rowValue, row, extraData) => {
        let defaultValue = {};

        let selectedBillingPractice = extraData.find((data) => {
          return (
            data.practice_cust_id ===
            billingMappingFromSelectedCustomer
              .find((mapping) => mapping.startsWith(row.practice_cust_id))
              ?.split(":")[1]
          );
        });

        if (selectedBillingPractice) {
          defaultValue = {
            value: selectedBillingPractice.index,
            label: selectedBillingPractice.practice_id_name,
          };
        } else {
          defaultValue = {
            value: row.index,
            label: row.practice_id_name,
          };
        }
        return `${defaultValue?.label}`;
      },
      enableResizing: true,
    },

    {
      accessorKey: "address",
      header: "Address",
      Cell: ({ renderedCellValue }) => {
        return <div>{renderedCellValue === "" ? "--" : renderedCellValue}</div>;
      },
      sort: true,
      csvExport: true,
      csvFormatter: (rowValue) => {
        return `${rowValue === "" ? "--" : rowValue}`;
      },
      enableResizing: true,
    },
    {
      accessorKey: "city",
      header: "City",
      Cell: ({ renderedCellValue }) => {
        return <div>{renderedCellValue === "" ? "--" : renderedCellValue}</div>;
      },
      sort: true,
      csvExport: true,
      csvFormatter: (rowValue) => {
        return `${rowValue === "" ? "--" : rowValue}`;
      },
      enableResizing: true,
    },
    {
      accessorKey: "state",
      header: "State",
      Cell: ({ renderedCellValue }) => {
        return <div>{renderedCellValue === "" ? "--" : renderedCellValue}</div>;
      },
      sort: true,
      csvExport: true,
      csvFormatter: (rowValue) => {
        return `${rowValue === "" ? "--" : rowValue}`;
      },
      enableResizing: true,
    },
    {
      accessorKey: "zip_code",
      header: "Zip Code",
      Cell: ({ renderedCellValue }) => {
        return <div>{renderedCellValue === "" ? "--" : renderedCellValue}</div>;
      },
      sort: true,
      csvExport: true,
      csvFormatter: (rowValue) => {
        return `${rowValue === "" ? "--" : rowValue}`;
      },
      enableResizing: true,
    },
    {
      accessorKey: "phone",
      header: "Phone",
      Cell: ({ renderedCellValue }) => {
        return <div>{renderedCellValue === "" ? "--" : renderedCellValue}</div>;
      },
      sort: true,
      csvExport: true,
      csvFormatter: (rowValue) => {
        return `${rowValue === "" ? "--" : rowValue}`;
      },
      enableResizing: true,
    },
    {
      accessorKey: "email",
      header: "Email",
      Cell: ({ renderedCellValue }) => {
        return <div>{renderedCellValue === "" ? "--" : renderedCellValue}</div>;
      },
      sort: true,
      csvExport: true,
      csvFormatter: (rowValue) => {
        return `${rowValue === "" ? "--" : rowValue}`;
      },
      enableResizing: true,
    },
    {
      accessorKey: "custid",
      header: "Customer ID",
      Cell: ({ renderedCellValue }) => {
        return <div>{renderedCellValue === "" ? "--" : renderedCellValue}</div>;
      },
      sort: true,
      csvExport: true,
      csvFormatter: (rowValue) => {
        return `${rowValue === "" ? "--" : rowValue}`;
      },
      enableResizing: true,
    },
  ];

  const handlePracticeLocationUpdate = () => {
  
    if (
      (isNewCustomerFlow || isApiAccessOnFlow) &&
      selectedPracticeLocations.filter((e) => e !== undefined).length === 0
    ) {
      toast.warn("Please select at least one practice location.");
      return;
    }

    // FOR SELECTED PRACTICES ------------
    let selectedPractices = selectedPracticeLocations
      .filter((e) => e !== undefined)
      .map((data) => `${data?.practice_id}|${data?.custid}`);

    // FOR SELECTED BILLING MAPPING ----------
    let selectedBillingMapping = selectedPracticeLocations
      .filter((e) => e !== undefined)
      .map((prac) => {
        //prac.practice_name
        let findFromCollection = collectionBillingPracWithPracticeID.find(
          (data) => {
            return data.practice_id === prac.practice_id;
          }
        );

        let newCustID = practiceLocationData.find(
          (data) => data.index === findFromCollection.selectObj.value
        );
        return `${prac.practice_cust_id}:${newCustID.practice_cust_id}`;
      });

    // FOR SELECTED BILLING LOCATION ------------
    let onlySelectedBillingLocation = selectedBillingMapping.map(
      (data) => data.split(":")[1]
    );
    let selectedBillingLocations = [
      ...new Set(onlySelectedBillingLocation),
    ].map((loc) => {
      let foundData = practiceLocationData.find(
        (data) => data.billing_mapping_id === loc
      );
      return `${foundData.billing_mapping_id}:${foundData.practice_name}`;
    });

    let body = {};

    let authPracticeDetailsChild = [];

    let selectedBillingMappingCopy = [...selectedBillingMapping]; //for final inserted rows (will store newly updated practice locations)
    let previousSelectedPracticeLocationCopy = [
      ...billingMappingFromSelectedCustomer,
    ]; // for final removed rows (will store old selected practice locations)

    selectedBillingMapping.forEach((data, index) => {
      let foundIdx = billingMappingFromSelectedCustomer.findIndex((d) => {
        return d === data;
      });
      if (foundIdx > -1) {
        let idx1 = selectedBillingMappingCopy.findIndex((d) => {
          return d === data;
        });
        selectedBillingMappingCopy.splice(idx1, 1);
        // let idx2 = previousSelectedPracticeLocationCopy.findIndex((d) => {
        //   return d === data;
        // });
        // previousSelectedPracticeLocationCopy.splice(idx2, 1);
      }
    });

    billingMappingFromSelectedCustomer.forEach((data) => {
      defaultSelectedPractices.forEach((d) => {
        if (data.split(":")[0].split("|")[0] === d) {
          let removedIdx = previousSelectedPracticeLocationCopy.findIndex(
            (val) => val === data
          );
          previousSelectedPracticeLocationCopy.splice(removedIdx, 1);
        }
      });
    });

    if (
      selectedBillingMappingCopy.length >= 0 ||
      previousSelectedPracticeLocationCopy.length >= 0
    ) {
      if (
        !arrayEquals(
          selectedBillingMappingCopy,
          previousSelectedPracticeLocationCopy
        )
      ) {
        //adding added practices into authPracticeDetailsChild
        selectedBillingMappingCopy.forEach((data) => {
          let foundOnlyBillingPractice = previousSelectedPracticeLocationCopy.find(
            (d) => {
              return d.split(":")[0] === data.split(":")[0];
            }
          );

          let foundOnlyBillingPracticeIdx = previousSelectedPracticeLocationCopy.findIndex(
            (data) => {
              return data.split(":")[0] === data.split(":")[0];
            }
          );

          if (foundOnlyBillingPractice) {
            // practice location did not change, only billing changed(the practice was already selected)
            let foundUpdatedPracticeOnlyBillingChanged = practiceLocationData.find(
              (d) => {
                return d.practice_cust_id === data.split(":")[0];
              }
            );
            authPracticeDetailsChild.push({
              auth_practice_details_child_id: "",
              api_unique_id:
                selectCustomerForPracticeLocationUpdate.api_unique_id,
              master_customer_id:
                selectCustomerForPracticeLocationUpdate.master_customer_id,
              app_id: applicationDetails.app_id,
              practice_id: foundUpdatedPracticeOnlyBillingChanged.practice_id,
              cust_id: foundUpdatedPracticeOnlyBillingChanged.custid,
              practice_cust_id:
                foundUpdatedPracticeOnlyBillingChanged.practice_cust_id,
              opt_flag: "1", // value should be 1 or 0. when user select location then value should be 1. when user removed location then value sholud be 0
              billing_location: data.split(":")[1],
              comment: `Updated By:${loginUserDetails.user_name}`, // fixed for now. Updated By: + logged in user's Email
              command: "update", //value should be insert/update. when user select location then value should be insert. when user removed location then value sholud be update
            });

            previousSelectedPracticeLocationCopy.splice(
              foundOnlyBillingPracticeIdx,
              1
            );
          } else {
            let foundInsertedPractice = practiceLocationData.find((d) => {
              return d.practice_cust_id === data.split(":")[0];
            });
            authPracticeDetailsChild.push({
              auth_practice_details_child_id: "",
              api_unique_id:
                selectCustomerForPracticeLocationUpdate.api_unique_id,
              master_customer_id:
                selectCustomerForPracticeLocationUpdate.master_customer_id,
              app_id: applicationDetails.app_id,
              practice_id: foundInsertedPractice.practice_id,
              cust_id: foundInsertedPractice.custid,
              practice_cust_id: foundInsertedPractice.practice_cust_id,
              opt_flag: "1", // value should be 1 or 0. when user select location then value should be 1. when user removed location then value sholud be 0
              billing_location: data.split(":")[1],
              comment: `Updated By:${loginUserDetails.user_name}`, // fixed for now. Updated By: + logged in user's Email
              command: "insert", //value should be insert/update. when user select location then value should be insert. when user removed location then value sholud be update
            });
          }
        });

        //removing removed practices into authPracticeDetailsChild
        previousSelectedPracticeLocationCopy.forEach((data) => {
          let foundRemovedPractice = practiceLocationData.find((d) => {
            return d.practice_cust_id === data.split(":")[0];
          });
          if (foundRemovedPractice) {
            authPracticeDetailsChild.push({
              auth_practice_details_child_id: "",
              api_unique_id:
                selectCustomerForPracticeLocationUpdate.api_unique_id,
              master_customer_id:
                selectCustomerForPracticeLocationUpdate.master_customer_id,
              app_id: applicationDetails.app_id,
              practice_id: foundRemovedPractice.practice_id,
              cust_id: foundRemovedPractice.custid,
              practice_cust_id: foundRemovedPractice.practice_cust_id,
              opt_flag: "0", // value should be 1 or 0. when user select location then value should be 1. when user removed location then value sholud be 0
              billing_location: data.split(":")[1],
              comment: `Updated By:${loginUserDetails.user_name}`, // fixed for now. Updated By: + logged in user's Email
              command: "update", //value should be insert/update. when user select location then value should be insert. when user removed location then value sholud be update
            });
          }
        });

        let oldSelectedPracticesArray = activity
          .find((data) => data.master_customer_id === masterCustomerID)
          .practice_id.split(",");

        // new selected practices are wholly different than old selected practices
        oldSelectedPracticesArray.forEach((oldData) => {
          let foundOldSelectedPrac = selectedPractices.findIndex((newData) => {
            return newData === oldData;
          });

          // present in old selected practices but not there
          if (foundOldSelectedPrac === -1) {
            if (
              authPracticeDetailsChild.findIndex(
                (d) => d.practice_cust_id === oldData
              ) === -1
             && oldData !=""
            ) {
            
              
              // checking if practice_cust_id not present in authPracticeDetailsChild Array
              authPracticeDetailsChild.push({
                auth_practice_details_child_id: "",
                api_unique_id:
                  selectCustomerForPracticeLocationUpdate.api_unique_id,
                master_customer_id:
                  selectCustomerForPracticeLocationUpdate.master_customer_id,
                app_id: applicationDetails.app_id,
                practice_id: oldData.split("|")[0],
                cust_id: oldData.split("|")[1],
                practice_cust_id: oldData,
                opt_flag: "0", // value should be 1 or 0. when user select location then value should be 1. when user removed location then value sholud be 0
                billing_location: oldData,
                comment: `Updated By:${loginUserDetails.user_name}`, // fixed for now. Updated By: + logged in user's Email
                command: "update", //value should be insert/update. when user select location then value should be insert. when user removed location then value sholud be update
              });
            }
          }
        });

        body = {
          app_id: applicationDetails.app_id,
          master_customer_id: masterCustomerID,
          selected_practices: selectedPractices, //practice_id and cust_id with pipe sign. you can get this above select API field name is practice_cust_id
          selected_billing_mapping: selectedBillingMapping, //location mapping with billing location value of before : is practice_cust_id and after : is practice_cust_id of billing location. Will explain in details on call.
          selected_billing_location: selectedBillingLocations, //Billing locations with location name
          app_name: applicationDetails.app_name,
          dev_id: devid,
          partner_name: applicationDetails.partner_name,
          add_updated_by: loginUserDetails.user_name,
          old_selected_practices: activity.find(
            (data) => data.master_customer_id === masterCustomerID
          ).practice_id, // You can get this using partners_customer_list API. you already call this API to dispalay customer list
          old_selected_billing_mapping: activity.find(
            (data) => data.master_customer_id === masterCustomerID
          ).billing_mapping, // You can get this using partners_customer_list API. you already call this API to dispalay customer list
          old_selected_billing_location: activity.find(
            (data) => data.master_customer_id === masterCustomerID
          ).billing_location, // You can get this using partners_customer_list API. you already call this API to dispalay customer list
          is_add_updated_by_admin:
            loginUserDetails.is_partner === "0" ? "true" : "false", //true if update from sikka admin side else false
          auth_practice_details_child: authPracticeDetailsChild,
          enterprise_fee_applied: showEnterpriseFeeAlert,
          selected_location_count: defaultSelectedPractices.length,
          enterprise_fee_threshold: enterpriseLocationThreshold,
        };
      } else if (!isApiAccessOnFlow) {
        toast.warn("You have already saved this Practice(s) location.");
      }
    } else if (!isApiAccessOnFlow) {
      toast.warn("You have already saved this Practice(s) location.");
    }

    if (typeof onSaveSuccess === "function") {
      const showError = (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        toast.error(resMessage);
        setLoading(false);
      };

      const postPracticeLocation = (finalBody, createdCustomer) => {
        APICall.servertrip(
          "POST",
          "practice_location",
          loginUserDetails,
          undefined,
          finalBody
        ).then((res) => {
          toast.success("Practice Location successfully changed");

          onSaveSuccess(createdCustomer);
          setEditPracticeLocationModal(false);
          setFetchData(true);
        }, showError);
      };

      if (isApiAccessOnFlow) {

        onSaveSuccess(Object.keys(body).length > 0 ? body : null);
        setEditPracticeLocationModal(false);
        return;
      }

      if (Object.keys(body).length === 0) {
        return;
      }

      setLoading(true);
      if (isNewCustomerFlow && typeof onCreateCustomer === "function") {

        onCreateCustomer().then((createdCustomer) => {
          postPracticeLocation(
            {
              ...body,
              auth_practice_details_child: body.auth_practice_details_child.map(
                (child) => ({
                  ...child,
                  api_unique_id: createdCustomer.api_unique_id,
                  master_customer_id: createdCustomer.master_customer_id,
                })
              ),
            },
            createdCustomer
          );
        }, showError);
      } else {
        postPracticeLocation(body);
      }
      return;
    }

    if (Object.keys(body).length > 0) {
      setLoading(true);
      APICall.servertrip(
        "POST",
        "practice_location",
        loginUserDetails,
        undefined,
        body
      ).then(
        (res) => {
          toast.success("Practice Location successfully changed");
          setUpdateDataFlag(true);
          setEditPracticeLocationModal(false);
          setFetchData(true);
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          toast.error(resMessage);
          setLoading(false);
          setEditPracticeLocationModal(false);
        }
      );
    }
  };

  // const selectRow = {
  //   mode: "checkbox", // single row selection
  //   selected: defaultSelectedPractices,
  //   clickToSelect: false,
  //   onSelect: (row, isSelect, rowIndex, e) => {
  //     if (isSelect) {
  //       //selectedPracticeLocationsPreviousCopy
  //       if (!selectedPracticeLocationsPreviousCopy.filter((prac) => prac?.practice_id === row.practice_id).length > 0) {
  //         setSelectedPracticeLocations(selectedPracticeLocations.concat(row));
  //       }
  //       if (!defaultSelectedPractices.find((data) => data === row.practice_id)) {
  //         setDefaultSelectedPractices(defaultSelectedPractices.concat(row.practice_id));
  //       }
  //       // collectionBillingPracWithPracticeIDCopy
  //       // setSelectedBillingPracticeWithPracticeID({
  //       //   selectObj: collectionBillingPracWithPracticeIDCopy.find(data =?),
  //       //   practice_id: row.practice_id,
  //       // });
  //     } else {
  //       let idx = selectedPracticeLocations.findIndex((prac) => prac.practice_id === row.practice_id);
  //       selectedPracticeLocations.splice(idx, 1);
  //       setSelectedPracticeLocations(selectedPracticeLocations.map((val) => val));

  //       let defaultIdx = defaultSelectedPractices.findIndex((data) => data === row.practice_id);
  //       defaultSelectedPractices.splice(defaultIdx, 1);
  //       setDefaultSelectedPractices(defaultSelectedPractices);
  //     }
  //   },
  //   onSelectAll: (isSelect, rows) => {
  //     if (isSelect) {
  //       setSelectedPracticeLocations([...rows]);
  //       let selectedDefaultPractices = [];
  //       rows.forEach((r) => {
  //         selectedDefaultPractices.push(r.practice_id);
  //       });
  //       setDefaultSelectedPractices(selectedDefaultPractices);
  //     } else {
  //       setSelectedPracticeLocations([]);
  //       setDefaultSelectedPractices([]);
  //       setSelectedPracticeLocationsPreviousCopy([]);
  //     }
  //   },
  // };

  useEffect(() => {
    //do something when the row selection changes...
    if (practiceLocationData.length > 0) {
      let selectedPracticeLocationLocalObj = [];
      let defaultSelectedPracticesLocalObj = [];

      for (const key in rowSelection) {
        selectedPracticeLocationLocalObj.push(
          practiceLocationData.find((prac) => prac.practice_id === key)
        );

        let foundPractice = practiceLocationData.find((prac) => {
          return prac.practice_id === key;
        });
        if (foundPractice && Object.keys(foundPractice).length > 0) {
          defaultSelectedPracticesLocalObj.push(foundPractice.practice_id);
        }
      }
      setSelectedPracticeLocations([...selectedPracticeLocationLocalObj]);
      setDefaultSelectedPractices([...defaultSelectedPracticesLocalObj]);
    }
  }, [rowSelection, practiceLocationData]);

  return (
    <div>
      {showEnterpriseFeeAlert && (
        <Alert
          className="d-flex align-items-start m-3"
          style={{
            gap: "0.75rem",
            backgroundColor: "#ffe8c8",
            borderColor: "#b38e50",
            borderRadius: "1rem",
          }}
        >
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className="mt-1"
            style={{
              flexShrink: 0,
              color: "#b38e50",
              fontSize: "1.5rem",
            }}
          />
          <div>
            <h5 className="mb-2 fw-bold" style={{ color: "#b38e50" }}>
              Sikka high-performance platform fee applies
            </h5>
            <p className="mb-0" style={{ color: "#6b6b6b", lineHeight: "1.6" }}>
              You've selected{" "}<strong>{enterpriseLocationThreshold} or more practice locations</strong>
              , which qualifies as a DSO customer under your Sikka agreement. A
              recurring monthly platform fee will be added to your invoice.
            </p>
          </div>
        </Alert>
      )}
      <APIPortalTable
        data={practiceLocationData}
        columns={materialColumns}
        loading={loading}
        enablePagination={true}
        enableRowSelection
        enableMultiRowSelection
        onRowSelectionChange={setRowSelection}
        getRowId={(originalRow) => {
          return originalRow.practice_id;
        }}
        enableSelectAll
        selectAllMode="all"
        state={{ rowSelection }}
        CSVFileName={"Selected Practice(s) Data.csv"}
        muiBottomToolbarProps={{
          sx: {
            borderBottomRightRadius: "0.395rem",
            borderBottomLeftRadius: "0.395rem",
            zIndex: 0,
          },
        }}
        muiTableBodyRowProps={{
          sx: {
            zIndex: "static",
            position: 0,
            backgroundColor:"unset",
            background:"unset"
          },
        }}
        extraButton={
          <>
            <CSVLink
              color="falcon-primary"
              filename={"Download Selected Data.csv"}
              style={{
                color: "#2c7be5",
                backgroundColor: isDark ? "#132238" : "#fff",
                borderColor: "#2c7be5",
                borderWidth: "1px",
                boxShadow:
                  "0 0 0 1px rgba(43,45,80,0.1), 0 2px 5px 0 rgba(43,45,80,0.08), 0 1px 1.5px 0 rgba(0,0,0,0.07), 0 1px 2px 0 rgba(0,0,0,0.08)",
                padding: "0.1875rem 0.75rem",
                fontSize: "0.875rem",
                borderRadius: "0.2rem",
                fontWeight: "500",
                textAlign: "center",
                verticalAlign: "middle",
                textDecoration: "none",
                transition:
                  "color 0.15s ease-in-out,background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out",
              }}
              data={selectedPracticeLocationsPreviousCopy}
              headers={
                practiceLocationData.length > 0
                  ? Object.keys(practiceLocationData[0]).map((item) => {
                      let formatItem = item.includes("_")
                        ? item?.replaceAll("_", " ")
                        : item;
                      formatItem = CaptitalizeString(formatItem);
                      return { label: formatItem, key: item };
                    })
                  : []
              }
            >
              <FontAwesomeIcon icon={faDownload} />{" "}
              {" .Download Selected locations"}
            </CSVLink>
          </>
        }
      />

      <Row
        className="modal-footer bg-light m-1"
        style={{ marginBottom: "-16px" }}
      >
        <h6 className="fs--1 fw-medium text-700 ">
          Selected Practice(s): {defaultSelectedPractices?.length}
        </h6>
        <h6 className="fs--1 fw-medium text-700">
          Total Practice(s): {practiceLocationData?.length}
        </h6>
        <Button
          className="ml-auto"
          size="sm"
          color="outline-primary"
          type="submit"
          onClick={handlePracticeLocationUpdate}
        >
          {isApiAccessOnFlow ? "Next" : "Save"}
        </Button>
        <Button
          size="sm"
          color="outline-danger"
          onClick={() => {
            setEditPracticeLocationModal(false);
          }}
        >
          Cancel
        </Button>
      </Row>
    </div>
  );
};

export default EditPracticeLocationModal;
